import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { formatCurrency } from 'aurora-utils/utils';
import messages from 'aurora-translations';
import ADGMImage from '../../ADGMImage';
import ADGMAlert from '../../ADGMAlert';
import styles from './styles';

function Layout(props) {
  const {
    classes,
    history,
    type,
    title,
    subTitle,
    data,
    downloadhandler,
    isShowPdfButton,
    isShowTranctions,
    isShowCalendarButton,
    isSellPurhcaseSuccess,
  } = props;
  const [propertyObject, setPropertyObject] = useState('');
  let lang = localStorage.getItem('lang');
  useEffect(() => {
    lang = localStorage.getItem('lang');
    if (lang === 'en') {
      setPropertyObject(data?.en);
    } else {
      setPropertyObject(data?.ar);
    }
  }, [data]);

  const goToPropertyHandler = () => {
    history.push('/app/properties?type=ownership');
  };

  const goToAppointment = () => {
    history.push({
      pathname: '/app/applications/sell-purchase/appointment-booking',
      state: { ...data },
    });
  };

  const renderIcon = typeIcon => {
    if (typeIcon === 'rejection') {
      return 'contractImage.svg';
    }
    if (typeIcon === 'termination') {
      return 'errorIcon.svg';
    }
    if (typeIcon === 'dmtPayment') {
      return 'DMTPaymentuccess.svg';
    }
    return 'successIcon.svg';
  };

  const renderClass = typeClass => {
    if (typeClass === 'rejection') {
      return classes.textHolder;
    }
    if (typeClass === 'termination') {
      return classes.textHolderTermination;
    }
    if (typeClass === 'dmtPayment') {
      return classes.textHolderApproval;
    }
    return classes.textHolderApproval;
  };

  return (
    <Container className={classes.container}>
      <Hidden smUp>
        <div className={classes.mobileTitlehead}>
          <div>
            <FormattedMessage {...messages.success} />
          </div>
        </div>
      </Hidden>
      <Grid container spacing={3} justify='center'>
        <Grid item xs={12} md={6}>
          <div className={classes.contentArea}>
            <div className={classes.bannerArea}>
              <Hidden smUp>
                <div className={classes.textHolder}>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </div>
              </Hidden>
              <div>
                <ADGMImage name={renderIcon(type)} alt='success img' />
              </div>
              <div className={renderClass(type)}>
                <Hidden smDown>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </Hidden>
                <Typography variant='body1'>{subTitle}</Typography>
                {isShowCalendarButton && isShowCalendarButton === true ? (
                  <Button variant='outlined' className={classes.btnADGMOutlineBlack} size='large'>
                    <FormattedMessage {...messages.add_appointment_calendar} />
                  </Button>
                ) : (
                  ''
                )}
              </div>
            </div>
            {isShowPdfButton && isShowPdfButton === true ? (
              <Typography align='right'>
                <Link href='#' variant='body1' className={classes.textDownload} onClick={downloadhandler}>
                  <ADGMImage name='Download-contract.svg' alt='Icon' /> <FormattedMessage {...messages.download_PDF} />
                </Link>
              </Typography>
            ) : (
              ''
            )}
            <Typography align='right' className={classes.applicationIdStyle}>
              <FormattedMessage {...messages.Application_ID} /> : <strong>{propertyObject?.applicationNumber}</strong>
            </Typography>
            <div className={classes.detailItemHolder}>
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.property} />
                  </Typography>
                  <Typography variant='h6' component='h2'>
                    {propertyObject?.title}
                  </Typography>
                </div>
                <Chip
                  label={propertyObject?.type && <FormattedMessage {...messages[propertyObject?.type]} />}
                  color='primary'
                  className={classNames(classes.darkgray, classes.uniChip)}
                />
              </div>
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.seller} />
                  </Typography>
                  {propertyObject?.seller?.map((item, index) => {
                    return (
                      <Typography variant='h6' component='h2' key={item?.ownerId}>
                        <FormattedMessage {...messages.seller_num} />
                        {index + 1}: {lang === 'ar' ? item?.nameAr : item?.nameEn} ({item?.sharePercentage}%)
                      </Typography>
                    );
                  })}
                </div>
              </div>
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.buyer} />
                  </Typography>
                  {propertyObject?.buyer?.map((item, index) => {
                    return (
                      <Typography variant='h6' component='h2' key={item?.ownerId}>
                        <FormattedMessage {...messages.buyer_num} values={{ num: index + 1 }} />:{' '}
                        {lang === 'ar' ? item?.nameAr : item?.nameEn} ({item?.sharePercentage}%)
                      </Typography>
                    );
                  })}
                </div>
              </div>
              {data?.serviceFees && (
                <div className={classes.detailItem}>
                  <div className={classes.text}>
                    <Typography variant='body1'>
                      <FormattedMessage {...messages.service_fee} />
                    </Typography>
                    <Typography variant='h6' component='h2'>
                      {data?.serviceFees}
                    </Typography>
                  </div>
                </div>
              )}
              {isShowTranctions === true ? (
                <>
                  <div className={classes.detailItem}>
                    <div className={classes.text}>
                      <Typography variant='body1'>
                        <FormattedMessage {...messages.transaction_fee} />
                      </Typography>
                      <Typography variant='h6' component='h2'>
                        <span className={classes.textDanger}>
                          {formatCurrency(propertyObject?.transactionFee || propertyObject?.transctiomAmount)}
                        </span>{' '}
                        (
                        <FormattedMessage
                          {...messages.transfee_text2}
                          values={{
                            s: `${propertyObject?.transactionFeePercent}`,
                          }}
                        />
                        {formatCurrency(propertyObject?.transactionAmount || propertyObject?.totalAmount)})
                      </Typography>
                      {/* <div className={classes.feeInfo}>
                        <img src={InformationGrey} alt='Icon' /> <FormattedMessage {...messages.to_be_paid_dmt} />
                      </div> */}
                      <ADGMAlert type='mute' visible noBackground className={classes.feeInfo}>
                        <FormattedMessage {...messages.to_be_paid_dmt} />
                      </ADGMAlert>
                    </div>
                  </div>
                  <div className={classes.detailItem}>
                    <div className={classes.text}>
                      <Typography variant='body1'>
                        <FormattedMessage {...messages.Transaction_fee_paid_by} />
                      </Typography>
                      <Typography variant='h6' component='h2'>
                        {propertyObject?.paidBy}
                      </Typography>
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
            <div className={classes.fixedonMobileHolder}>
              {isShowTranctions === true ? (
                isSellPurhcaseSuccess === true ? (
                  <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                    <FormattedMessage {...messages.go_to_properties} />
                  </Button>
                ) : (
                  <Button variant='contained' className={classes.gotoproBtn} onClick={goToAppointment}>
                    <FormattedMessage {...messages.make_an_appointment} />
                  </Button>
                )
              ) : (
                <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                  <FormattedMessage {...messages.back_to_properties} />
                </Button>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  isShowTranctions: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
  isShowCalendarButton: PropTypes.bool.isRequired,
  isSellPurhcaseSuccess: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Layout);
